<script>
	/*
		TCareReferralContactInfoFields.svelte

		Renders a block of user input fields.
		Returned value will be all the field values.

		const userInfoObject = {
			firstName: null,
			lastName: null,
			address1: null,
			address2: null,
			county: null,
			state: null,
			city: null,
			postalCode: null,
			country: null,
			phoneNumber: null,
			email: null
		}

		KEEP ALL STYLING LOCAL TO THIS FILE!

	*/

    import TCareFieldPair from "./TCareFieldPair.svelte";

	export let source;
	export let setValue;
	
</script>

<style>

	.user-info-fields {
		width: 100%;
		margin: 20px 0px;
		/* border: 1px solid purple; */
	}

	.user-info-fields .spacer {
		width: 10%;
	}

	.user-info-fields .spacer-100 {
		width: 100%;
	}

	.user-info-fields .user-info {
		margin: -20px 0px 20px 10px;
		font-size: 14px;
		line-height: 16px;
		color: #887392;
	}

</style>

<!-- this is a block of user input fields -->

<div class="tcui-control user-info-fields">
	<div class="flex-row">
		<div class="user-info">Tell us about who this resource is for.</div>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['firstName']} prop={'value'} {setValue} 
			label={source['firstName'].label} isRequired={source['firstName'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['address1']} prop={'value'} {setValue} 
			label={source['address1'].label} isRequired={source['address1'].isRequired}
		/>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['lastName']} prop={'value'} {setValue} 
			label={source['lastName'].label} isRequired={source['lastName'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['address2']} prop={'value'} {setValue} 
			label={source['address2'].label} isRequired={source['address2'].isRequired}
		/>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['phoneNumber']} prop={'value'} {setValue} 
			label={'Phone Number'} isRequired={source['phoneNumber'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['county']} prop={'value'} {setValue} 
			label={'County'} isRequired={source['county'].isRequired}
		/>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['state']} prop={'value'} {setValue} 
			label={'State'} isRequired={source['state'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['city']} prop={'value'} {setValue} 
			label={'City'} isRequired={source['city'].isRequired}
		/>
	</div>
	<div class="flex-row">
		<TCareFieldPair source={source['email']} prop={'value'} {setValue} 
			label={'Email'} isRequired={source['email'].isRequired}
		/>
		<div class="spacer"></div>
		<TCareFieldPair source={source['postalCode']} prop={'value'} {setValue} 
			label={'ZIP Code'} isRequired={source['postalCode'].isRequired}
		/>
	</div>
</div>

